import SubmitRequest, {
	action as SubmitRequestAction,
	loader as SubmitRequestLoader,
} from './SubmitRequest';

export default SubmitRequest;
export { SubmitRequestAction, SubmitRequestLoader };
